import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaQuestionCircle, FaPlus, FaTrash, FaEye, FaEyeSlash, FaSync } from "react-icons/fa";
import { MdOutlinePushPin, MdPushPin } from "react-icons/md";
import $ from "jquery";

import Pagination from "Components/Pagination";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { getFileDownload, toggleFaqPin, deleteFaq, getFaqList } from "JS/API";
import FaqWriteModal from "./../Components/FaqWriteModal";
import { listPageStyles } from "utils/designSystem";

const Faq = () => {
  const navigate = useNavigate();
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 10,
  });
  const [openWriteFaq, setOpenWriteFaq] = useState(false);
  const [category, setCategory] = useState("전체");
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [searchData] = useState({
    markType: "all",
    progress: "all",
    applicantType: "all",
    startDate: "",
    endDate: "",
    markName: "",
    user_id: "",
    user_name: "",
    sort: "apply_date_desc",
  });
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [list, setList] = useState([]);
  let prevent = false;
  // 체크된 항목 ID들을 저장하는 상태
  const [idArr, setIdArr] = useState([]);
  const [, setImageUrls] = useState({});

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: listPageStyles.header,
    title: listPageStyles.title,
    controlCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #cbd5e1',
      padding: '24px',
      marginBottom: '24px'
    },
    controlRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '16px',
      flexWrap: 'wrap'
    },
    filterGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    select: listPageStyles.select,
    changeButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    actionSection: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px'
    },
    writeButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    deleteButton: listPageStyles.deleteButton,
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '900px'
    },
    th: listPageStyles.th,
    td: listPageStyles.td,
    checkbox: listPageStyles.checkbox,
    checkboxLabel: listPageStyles.checkboxLabel,
    pinIcon: {
      cursor: 'pointer',
      transition: 'color 0.2s ease'
    },
    pinIconActive: {
      color: '#dc2626'
    },
    pinIconInactive: {
      color: '#9ca3af'
    },
    questionTitle: {
      fontWeight: '500',
      color: '#0f172a'
    },
    adminId: {
      fontWeight: '500',
      color: '#374151'
    },
    category: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: '#f1f5f9',
      color: '#1e293b',
      textAlign: 'center'
    },
    statusActive: {
      color: '#059669',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    statusInactive: {
      color: '#dc2626',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    viewCount: {
      fontWeight: '600',
      color: '#6b7280',
      textAlign: 'center'
    }
  };

  const getList = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => (prevent = false), 200);

    const result = await getFaqList(pageInfo, category);

    if (typeof result === "object") {
      const data = result?.data?.data;
      setList(result?.data?.data);

      const imageFetches = data.map(async (item, index) => {
        let fileName = "";
        let originalName = "";

        if (item.mark_type === "FIGURE" || item.mark_type === "TEXT") {
          fileName = item.image_filename;
          originalName = item.image_original_filename;
        } else if (item.mark_type === "COMPOUND") {
          fileName = item.compound_image_filename;
          originalName = "복합상표";
        }

        if (fileName && originalName) {
          try {
            const url = await fetchUploadedImage(fileName, originalName);
            return { id: item.id, url };
          } catch (error) {
            console.error("이미지 URL 가져오기 오류:", error);
            return { id: item.id, url: null };
          }
        }

        return { id: item.id, url: null };
      });

      const resolvedImages = await Promise.all(imageFetches);

      const imageMap = {};
      resolvedImages.forEach(({ id, url }) => {
        if (url) imageMap[id] = url;
      });

      setImageUrls(imageMap);

      setPageInfo((prev) => {
        const clone = { ...prev };
        clone.totalPage = result?.data?.meta?.total_page;
        return clone;
      });
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 상단 고정 토글 함수
  const togglePin = async (id, currentPinStatus) => {
    try {
      const result = await toggleFaqPin(id, !currentPinStatus);

      if (typeof result === "object") {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "상단 고정이 변경되었습니다."
        );
        setAlert("pinUpdated");
      } else {
        return await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (error) {
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "상단 고정 변경에 실패했습니다."
      );
    }
  };

  // 새 FAQ 작성 모드
  const handleWriteNew = () => {
    setSelectedFaq(null);
    setOpenWriteFaq(true);
  };

  // FAQ 행 클릭 핸들러 (수정 모드)
  const handleRowClick = (faqData) => {
    const selectedData = {
      id: faqData.id,
      answer: faqData.answer,
      question: faqData.question,
      is_pinned: faqData.is_pinned,
      is_active: faqData.is_active,
      category: faqData.category,
    };
    setSelectedFaq(selectedData);
    setOpenWriteFaq(true);
  };

  // 체크박스 개별 선택
  const checkEach = (e) => {
    e.stopPropagation();
    let all = $(".agencies-check").length;
    let checked = $(".agencies-check:checked").length;
    let arr = [];
    if (all !== checked) $(".agencies-all-check").prop("checked", false);
    else $(".agencies-all-check").prop("checked", true);
    for (let i = 0; i < all; i++) {
      if (document.getElementsByClassName("agencies-check")[i].checked) {
        const val = document.getElementsByClassName("agencies-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    }
  };

  // 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".agencies-all-check").is(":checked")) {
      $(".agencies-check").prop("checked", true);
      const all = $(".agencies-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("agencies-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".agencies-check").prop("checked", false);
      setIdArr([]);
    }
  };

  const renderList = () => {
    return list?.map((faqItem, idx) => {
      const {
              id,
              category,
              question,
              is_active,
              is_pinned,
              view_count,
              created_at,
              admin_id,
            } = faqItem;

      const checkDragText = (e) => {
        const selection = window.getSelection();
        if (selection.toString().length > 0) {
          return;
        }
        handleRowClick(faqItem);
      };

      return (
        <tr 
          key={id}
          onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
          onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
        >
          <td style={styles.td} onClick={(e) => e.stopPropagation()}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                className="agencies-check"
                onChange={checkEach}
                value={id}
                style={styles.checkbox}
              />
            </label>
          </td>

          <td style={styles.td} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {is_pinned ? (
                <MdPushPin
                  size={20}
                  style={{...styles.pinIcon, ...styles.pinIconActive}}
                  onClick={() => togglePin(id, is_pinned)}
                />
              ) : (
                <MdOutlinePushPin
                  size={20}
                  style={{...styles.pinIcon, ...styles.pinIconInactive}}
                  onClick={() => togglePin(id, is_pinned)}
                />
              )}
            </div>
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            <div style={{ textAlign: 'center', fontWeight: '600' }}>{id}</div>
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            <div style={styles.questionTitle}>{question}</div>
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            <div style={styles.adminId}>{admin_id}</div>
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            <span style={styles.category}>{category}</span>
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            {created_at?.split("T")[0]}
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            {is_active ? (
              <span style={styles.statusActive}>
                <FaEye size={12} />
                노출
              </span>
            ) : (
              <span style={styles.statusInactive}>
                <FaEyeSlash size={12} />
                비노출
              </span>
            )}
          </td>

          <td style={styles.td} onClick={() => checkDragText()}>
            <div style={styles.viewCount}>{view_count}</div>
          </td>
        </tr>
      );
    });
  };

  const fetchUploadedImage = async (fileName, originalFileName) => {
    try {
      const response = await getFileDownload(fileName, originalFileName);
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      const mimeType = response.headers["content-type"];
      return `data:${mimeType};base64,${base64}`;
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
      return null;
    }
  };

  //= FAQ 다중 삭제
  const deleteAgencies = async () => {
    try {
      const faqIds = idArr.map((id) => parseInt(id));
      const result = await deleteFaq(faqIds);

      if (typeof result === "object") {
        $(".agencies-all-check").prop("checked", false);
        $(".agencies-check").prop("checked", false);
        changeState(setPageInfo, "page", 1);
        setIdArr([]);
        setAlert("completeDelete");
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "정상적으로 삭제되었습니다."
        );
      } else {
        return await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (error) {
      console.error("삭제 중 오류:", error);
      return await catchError(error, navigate, setAlertBox, setAlert);
    }
  };

  // 변경 버튼 클릭 핸들러
  const handleChangeFilter = () => {
    setPageInfo((prev) => ({ ...prev, page: 1 }));
    getList();
  };

  useEffect(() => {
    getList();
  }, [pageInfo.page, searchData.sort]);

  useEffect(() => {
    document.title = "마크픽 관리자 > FAQ 관리";
  }, []);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaQuestionCircle />
          FAQ
        </h1>
      </div>

      {/* 필터 및 설정 영역 */}
      <div style={styles.controlCard}>
        <div style={styles.controlRow}>
          <div style={styles.filterGroup}>
            <select
              value={pageInfo.limit}
              onChange={(e) => {
                setPageInfo((prev) => {
                  const clone = { ...prev };
                  clone.page = 1;
                  clone.limit = e.target.value;
                  return clone;
                });
              }}
              style={styles.select}
            >
              <option value="10">10개씩 보기</option>
              <option value="30">30개씩 보기</option>
              <option value="50">50개씩 보기</option>
            </select>

            <select
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
              style={styles.select}
            >
              <option value="전체">전체</option>
              <option value="상표">상표</option>
              <option value="비용및결제">비용 및 결제</option>
              <option value="상표모니터링">상표모니터링</option>
              <option value="회원정보">회원 정보</option>
              <option value="기타">기타</option>
              <option value="셀프상표출원">셀프 상표 출원</option>
              <option value="상표등록대행">상표 등록 대행</option>
              <option value="브랜드네이밍">브랜드 네이밍</option>
              <option value="상표등록가능성">상표 등록 가능성</option>
              <option value="위조상품/상표모니터링">
                위조상품 · 무단 상표 선점
              </option>
            </select>

            <button 
              style={styles.changeButton}
              onClick={handleChangeFilter}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaSync />
              변경
            </button>
          </div>
        </div>
      </div>

      {/* 액션 버튼들 */}
      <div style={styles.actionSection}>
        <button
          style={styles.writeButton}
          onClick={handleWriteNew}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#059669'}
        >
          <FaPlus />
          작성하기
        </button>

        <button
          style={styles.deleteButton}
          onClick={() => {
            if (!idArr.length)
              return commonModalSetting(
                setAlertBox,
                true,
                "alert",
                "삭제할 글을 선택해 주세요."
              );
            else {
              setAlert("deleteConfirm");
              commonModalSetting(
                setAlertBox,
                true,
                "confirm",
                "삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
              );
            }
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
        >
          <FaTrash />
          삭제하기
        </button>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>
                  <label style={styles.checkboxLabel}>
                    <input
                      type="checkbox"
                      className="agencies-all-check"
                      onChange={checkAll}
                      style={styles.checkbox}
                    />
                  </label>
                </th>
                <th style={styles.th}>상단 고정</th>
                <th style={styles.th}>No.</th>
                <th style={styles.th}>제목</th>
                <th style={styles.th}>작성자</th>
                <th style={styles.th}>카테고리</th>
                <th style={styles.th}>작성일</th>
                <th style={styles.th}>노출상태</th>
                <th style={styles.th}>조회수</th>
              </tr>
            </thead>

            <tbody>
              {list?.length > 0 ? (
                renderList()
              ) : (
                <tr>
                  <td colSpan="9" style={{...styles.td, textAlign: 'center', padding: '48px', color: '#6b7280'}}>
                    데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* FAQ 작성 모달 */}
      {openWriteFaq && (
        <FaqWriteModal
          setOpenWriteFaq={setOpenWriteFaq}
          setAlert={setAlert}
          setAlertBox={setAlertBox}
          getList={getList}
          selectedFaq={selectedFaq}
        />
      )}

      {/* 공통 모달 */}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "deleteConfirm") {
              deleteAgencies();
            } else if (alert === "completeDelete") {
              getList();
            } else if (alert === "pinUpdated") {
              getList();
            } else if (alert === "logout") {
              navigate("/");
            } else {
              return;
            }
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
      `}</style>
    </div>
  );
};

export default Faq;